import React from 'react';
import { LayoutDashboard } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { AdminDashboardLayout } from '@/components/admin/AdminDashboardLayout';

/**
 * Step 4 — Dashboard Layout (TYPE B: Optional Configuration)
 *
 * Shows an empty/informational state by default.
 * User clicks "Set Up Dashboard Layout Now" to expand the real settings page.
 * Has inline editor: yes.
 * This is the last step — Next button is labelled "Finish Setup →".
 */
interface StepDashboardLayoutProps {
  expanded: boolean;
  onExpand: () => void;
}

export const StepDashboardLayout: React.FC<StepDashboardLayoutProps> = ({
  expanded,
  onExpand,
}) => {
  if (expanded) {
    return (
      <div className="p-6 h-full">
        <div className="rounded-lg border border-border bg-white overflow-auto max-h-[calc(100vh-200px)]">
          <AdminDashboardLayout />
        </div>
      </div>
    );
  }

  return (
    <div className="p-6 flex items-center justify-center min-h-[60vh]">
      <div className="text-center max-w-md">
        {/* Icon */}
        <div className="w-16 h-16 rounded-2xl bg-primary/10 flex items-center justify-center mx-auto mb-5">
          <LayoutDashboard className="h-8 w-8 text-primary" />
        </div>

        {/* Heading */}
        <h3 className="text-lg font-semibold text-foreground mb-2">
          Configure Dashboard Layouts
        </h3>

        {/* Description */}
        <p className="text-sm text-muted-foreground leading-relaxed mb-6">
          Configure which cards appear on the dashboard for each role. This helps
          each user see the most relevant information immediately. You can do this
          later from{' '}
          <span className="font-medium text-foreground">
            Settings → Dashboard Layout
          </span>
          .
        </p>

        {/* CTA */}
        <Button onClick={onExpand}>
          Set Up Dashboard Layout Now
        </Button>
      </div>
    </div>
  );
};
